import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-20 py-5">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/ae7623a3d5e45641aa166269ca3c10ed.png" 
              alt="NorthStar Innovations AI" 
              className="h-10 w-auto"
            />
            <span className="text-xl font-semibold text-slate-900">NorthStar Innovations AI</span>
          </a>

          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('approach')}
              className="text-base text-slate-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Approach
            </button>
            <button
              onClick={() => scrollToSection('industries')}
              className="text-base text-slate-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Industries
            </button>
            <button
              onClick={() => scrollToSection('differentiation')}
              className="text-base text-slate-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('footer')}
              className="text-base text-slate-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('final-cta')}
            className="px-6 py-3 border-2 border-slate-900 text-slate-900 rounded-full hover:bg-slate-900 hover:text-white transition-all duration-200 text-sm font-medium cursor-pointer whitespace-nowrap"
          >
            Schedule Strategy Call
          </button>
        </div>
      </div>
    </nav>
  );
}
